import { createFileRoute } from '@tanstack/react-router';

import { UsersScreen } from '../../features/users/users-screen';
import { RequirePermission } from '../../lib/session/guards';
import { ADMIN_PERMISSIONS } from '../../lib/session/permissions';

export const Route = createFileRoute('/users/')({
  component: UsersPage,
});

/**
 * `/users` — staff, roles and invitations (MASTER_PLAN M11.9, FR-ADMIN-12).
 *
 * `tenant.users.read` opens the page; every action on it is `tenant.users.manage` or
 * `tenant.roles.assign` and is checked again on the server (rules §17.2, §22.2).
 */
function UsersPage() {
  return (
    <RequirePermission keys={[ADMIN_PERMISSIONS.usersRead]}>
      <UsersScreen />
    </RequirePermission>
  );
}
